<div class="container">
  <h2>Patient Notes</h2>
  <p class="description">
    Supervisor-only patient notes for sharing context within the supervisor
    module.
  </p>

  @if (isLoading()) {
    <div class="loading">
      <app-loading-indicator />
    </div>
  } @else {
    <div class="row">
      <div class="col-12">
        <div class="editor-container">
          <div class="editor-content">
            <ckeditor
              id="notes"
              name="notes"
              [editor]="Editor"
              [config]="editorConfig"
              [data]="initialNotes"
              (change)="onNotesChange($event)"
            ></ckeditor>
          </div>
        </div>
      </div>
    </div>

    <div class="actions mt-3">
      <button
        class="btn btn-primary save-button"
        (click)="saveNotes()"
        [disabled]="isSaving()"
      >
        {{ isSaving() ? 'Saving...' : 'Save Notes' }}
      </button>
    </div>
  }
</div>
